import type * as core from '../../../../../../../core'

const pointOnClick = (jiraStatusFilter: string) => ({
  '{}': {
    action: {
      '{}': {
        payload: {
          '{}': {
            goto: {
              '{}': {
                variables: {
                  '{}': {
                    jiraStatusFilter,
                    typeFilter: null,
                    assigneeFilter: null,
                    dueDateFilter: null,
                  },
                },
                navigationId: 'requirements-dashboard',
              },
            },
          },
        },
        operation: 'ui.navigate',
      },
    },
  },
})

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Requirements by Jira Status',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: '',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Requirements',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'To Do',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'toDo',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('To Do'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'In Progress',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'inProgress',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('In Progress'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'In Review',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'inReview',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('In Review'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'Done',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'done',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('Done'),
                                },
                              },
                              {
                                '{}': {
                                  x: 'Unknown',
                                  y: {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'unknown',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  onClick: pointOnClick('Unknown'),
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Jira Status',
                  yLabel: 'Requirements',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    toDo: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!jira_status',
              },
              'To Do',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    inProgress: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!jira_status',
              },
              'In Progress',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    inReview: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!jira_status',
              },
              'In Review',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    done: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!jira_status',
              },
              'Done',
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
    unknown: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@.': '!jira_status',
                  },
                  'Unknown',
                ],
              },
              {
                '=': [
                  {
                    '@.': '!jira_status',
                  },
                  null,
                ],
              },
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
      },
    },
  },
}
